export const WO_STATUSES = [
  "nueva", "asignada", "aceptada", "en_curso", "en_revision",
  "en_correccion", "aprobada", "cerrada", "cancelada", "en_pausa",
];

export const PRIORIDADES = ["baja", "media", "alta", "urgente"];
export const BILLING_STATUSES = ["pendiente", "facturado", "cobrado", "no_facturable"];
export const EVIDENCE_TYPES = ["antes", "despues", "correccion", "recibo"];
export const QUICK_VIEWS = [
  "sin_asignar", "vencidas", "esperando_aprobacion",
  "con_adicionales", "con_observaciones", "cerradas_sin_facturar",
];

const STATUS_TONE = {
  nueva: "gray",
  asignada: "blue",
  aceptada: "blue",
  en_curso: "amber",
  en_revision: "amber",
  en_correccion: "red",
  aprobada: "green",
  cerrada: "green",
  cancelada: "gray",
  en_pausa: "gray",
};

const SEMAFORO_TONE = { verde: "green", ambar: "amber", rojo: "red", gris: "gray" };
const PRIORIDAD_TONE = { baja: "gray", media: "blue", alta: "amber", urgente: "red" };
const BILLING_TONE = { pendiente: "amber", facturado: "blue", cobrado: "green", no_facturable: "gray" };

export const woStatusTone = (s) => STATUS_TONE[s] || "gray";
export const semaforoTone = (s) => SEMAFORO_TONE[s] || "gray";
export const prioridadTone = (p) => PRIORIDAD_TONE[p] || "gray";
export const billingTone = (b) => BILLING_TONE[b] || "gray";

export const lineStateTone = (e) =>
  ({ propuesto: "amber", autorizado: "green", rechazado: "red", aprobado: "blue" }[e] || "gray");

export function dueRelative(iso) {
  if (!iso) return "—";
  const diff = new Date(iso).getTime() - Date.now();
  const abs = Math.abs(diff);
  const hours = Math.round(abs / 3600000);
  const unit = hours >= 48 ? `${Math.round(hours / 24)} d` : `${hours} h`;
  return diff >= 0 ? `en ${unit}` : `hace ${unit}`;
}

export function marginPctLabel(wo) {
  if (wo?.margen_pct == null) return "—";
  return `${wo.margen_pct}%`;
}
